<div class="m180-page">

  <!-- Cabecera -->
  <div class="m180-header">
    <div class="m180-header__icon"><mat-icon>assignment</mat-icon></div>
    <div>
      <h1 class="m180-header__title">Modelo 180</h1>
      <p class="m180-header__sub">{{ title }}</p>
    </div>
  </div>

  <!-- Acciones -->
  <div class="m180-actions">
    <button mat-stroked-button class="m180-btn" (click)="getData()">
      <mat-icon>refresh</mat-icon> Calcular / Actualizar
    </button>
    <button mat-stroked-button class="m180-btn" (click)="getFile()">
      <mat-icon>file_download</mat-icon> Descargar fichero
    </button>
    <button mat-stroked-button class="m180-btn" (click)="validate()">
      <mat-icon>check</mat-icon> Validar datos
    </button>
    <button mat-stroked-button class="m180-btn" (click)="redirectFileTax()">
      <mat-icon>send</mat-icon> Presentar impuesto
    </button>
  </div>

  <!-- Alertas de validación -->
  <div class="m180-alerts" *ngIf="validations && validations.length > 0">
    <div class="m180-alert" *ngFor="let item of validations; trackBy: trackByIndex">
      <span class="m180-alert__text">{{ item.message }}</span>
      <button class="m180-alert__link" *ngIf="item.key" (click)="scrollToElement(item.key)">Ir al campo</button>
    </div>
  </div>

  <!-- Loading -->
  <div class="m180-loading" *ngIf="isLoading">
    <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
    <p>Calculando…</p>
  </div>

  <mat-tab-group animationDuration="0ms" *ngIf="!isLoading">

    <mat-tab label="Declarante y resumen de la declaración">
      <div class="m180-card" style="margin-top:16px">
        <div class="m180-card__head">
          <mat-icon>perm_identity</mat-icon>
          <span class="m180-card__head-label">Datos del declarante</span>
        </div>
        <div class="m180-card__body">
          <div class="m180-fields">
            <app-input inputType="text" placeholder="NIF" name="page1_Num_9_17" [(ngModel)]="data.page1_Num_9_17"></app-input>
            <app-input inputType="text" placeholder="Apellido y nombre o razón social del declarante" name="page1_Num_18_57" [(ngModel)]="data.page1_Num_18_57"></app-input>
            <app-input inputType="text" placeholder="Ejercicio" name="page1_Num_5_8" [(ngModel)]="data.page1_Num_5_8"></app-input>
          </div>

          <span class="m180-subhead">Persona con quién relacionarse</span>
          <div class="m180-fields">
            <app-input inputType="text" placeholder="Teléfono" name="page1_Num_59_67" [(ngModel)]="data.page1_Num_59_67"></app-input>
            <app-input inputType="text" placeholder="Apellidos y nombre" name="page1_Num_68_107" [(ngModel)]="data.page1_Num_68_107"></app-input>
          </div>

          <span class="m180-subhead">Resumen de la declaración</span>
          <div class="m180-fields">
            <div>
              <span class="m180-field-label">Número total de perceptores</span>
              <input class="m180-input-plain" [(ngModel)]="data.page1_Num_136_144" [readonly]="true">
            </div>
            <div>
              <span class="m180-field-label">Total base retenciones e ingresos a cuenta</span>
              <input class="m180-input-plain" [(ngModel)]="data.page1_Num_145_160" [readonly]="true">
            </div>
            <div>
              <span class="m180-field-label">Total retenciones e ingresos a cuenta</span>
              <input class="m180-input-plain" [(ngModel)]="data.page1_Num_161_175" [readonly]="true">
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Perceptores">
      <div class="m180-card" style="margin-top:16px">
        <div class="m180-card__head">
          <mat-icon>list</mat-icon>
          <span class="m180-card__head-label">Perceptores</span>
        </div>
        <div class="m180-card__body">
          <div class="m180-actions" style="margin-bottom:12px">
            <button mat-stroked-button class="m180-btn" (click)="openAddPerceptor(modelPerceptor)">
              <mat-icon>assignment</mat-icon> Añadir
            </button>
          </div>

          <div class="m180-table-wrap">
            <table class="m180-list-table">
              <thead>
                <tr>
                  <th>Orden</th>
                  <th>NIF del perceptor</th>
                  <th>NIF del representante legal</th>
                  <th>Apellidos y nombre, razón social o denominación del perceptor</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of data.perceptores; let i = index; trackBy: trackByIndex">
                  <td>{{ (i + 1) < 10 ? ('0' + (i + 1)) : (i + 1) }}</td>
                  <td>{{ p.nifPerceptor }}</td>
                  <td>{{ p.nifRepresentante }}</td>
                  <td>{{ p.nombrePerceptor }}</td>
                  <td class="text-end">
                    <button mat-stroked-button class="m180-btn" (click)="openEditPerceptor(modelPerceptor, p, i)">Editar</button>
                    <button mat-stroked-button class="m180-btn" (click)="deletePerceptor(i)">Eliminar</button>
                  </td>
                </tr>
                <tr *ngIf="!data.perceptores || data.perceptores.length === 0">
                  <td colspan="5" class="m180-list-empty">Sin perceptores añadidos</td>
                </tr>
              </tbody>
            </table>
          </div>

          <ng-template #modelPerceptor>
            <div class="m180-card" style="margin:16px" *ngIf="selectedPerceptor">
              <div class="m180-card__head">
                <mat-icon>list</mat-icon>
                <span class="m180-card__head-label">Datos de la operación</span>
              </div>
              <div class="m180-card__body">
                <div class="m180-actions" style="justify-content:flex-end;margin-bottom:12px">
                  <button mat-stroked-button class="m180-btn" (click)="savePerceptor()">
                    <mat-icon>check</mat-icon> Guardar
                  </button>
                  <button mat-stroked-button class="m180-btn" (click)="closeModal()">Cerrar</button>
                </div>

                <div class="m180-fields">
                  <app-input inputType="text" placeholder="NIF del perceptor" name="nifPerceptor" [(ngModel)]="selectedPerceptor.nifPerceptor"></app-input>
                  <app-input inputType="text" placeholder="NIF del representante legal" name="nifRepresentante" [(ngModel)]="selectedPerceptor.nifRepresentante"></app-input>
                  <app-input inputType="text" placeholder="Apellidos y nombre / Razón social" name="nombrePerceptor" [(ngModel)]="selectedPerceptor.nombrePerceptor"></app-input>
                  <app-input inputType="text" placeholder="Ejercicio de devengo" name="ejercicioDevengo" [(ngModel)]="selectedPerceptor.ejercicioDevengo"></app-input>

                  <div>
                    <span class="m180-field-label">Código provincia (perceptor)</span>
                    <select [(ngModel)]="selectedPerceptor.codigoProvinciaPerceptor" class="m180-native-select">
                      <option [ngValue]="''">--</option>
                      <option *ngFor="let pr of provinces; trackBy: trackByIndex" [ngValue]="pr.provinceCode || pr.code || pr.id">
                        {{ pr.name || pr.provinceName || pr.descripcion }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <span class="m180-field-label">Modalidad</span>
                    <input class="m180-input-plain" [readonly]="true" [value]="'1 - Arrendamiento'">
                  </div>

                  <app-input inputType="number" placeholder="Base retención" name="baseAnual" [(ngModel)]="selectedPerceptor.baseAnual"></app-input>
                  <app-input inputType="number" placeholder="% Retención" name="porcentajeRetencion" [(ngModel)]="selectedPerceptor.porcentajeRetencion"></app-input>
                  <app-input inputType="number" placeholder="Retención" name="retencionAnual" [(ngModel)]="selectedPerceptor.retencionAnual"></app-input>
                </div>

                <span class="m180-subhead">Datos del inmueble</span>
                <div class="m180-fields">
                  <div>
                    <span class="m180-field-label">Situación del inmueble</span>
                    <app-select name="situacionInmueble" [(ngModel)]="selectedPerceptor.situacionInmueble"
                      [config]="{ options: situacionInmuebleOptions }"></app-select>
                  </div>

                  <app-input inputType="text" placeholder="Referencia catastral" name="referenciaCatastral" [(ngModel)]="selectedPerceptor.referenciaCatastral"></app-input>

                  <div>
                    <span class="m180-field-label">Tipo de vía</span>
                    <select class="m180-native-select" [(ngModel)]="selectedPerceptor.streetTypeId">
                      <option [ngValue]="null">--</option>
                      <option *ngFor="let s of street_types; trackBy: trackByIndex" [ngValue]="s.id">
                        {{ s.description || s.name || s.text || s.key }}
                      </option>
                    </select>
                  </div>

                  <app-input inputType="text" placeholder="Nombre de la vía pública" name="address" [(ngModel)]="selectedPerceptor.address"></app-input>

                  <div>
                    <span class="m180-field-label">Tipo de numeración</span>
                    <select class="m180-native-select" [(ngModel)]="selectedPerceptor.numberingTypeId">
                      <option [ngValue]="null">--</option>
                      <option *ngFor="let n of numbering_types; trackBy: trackByIndex" [ngValue]="n.id">
                        {{ n.description || n.name || n.text || n.key }}
                      </option>
                    </select>
                  </div>

                  <app-input inputType="text" placeholder="Número" name="number" [(ngModel)]="selectedPerceptor.number"></app-input>
                  <app-input inputType="text" placeholder="Calificador" name="numberQualifier" [(ngModel)]="selectedPerceptor.numberQualifier"></app-input>
                  <app-input inputType="text" placeholder="Bloque" name="block" [(ngModel)]="selectedPerceptor.block"></app-input>
                  <app-input inputType="text" placeholder="Portal" name="entrance" [(ngModel)]="selectedPerceptor.entrance"></app-input>
                  <app-input inputType="text" placeholder="Escalera" name="staircase" [(ngModel)]="selectedPerceptor.staircase"></app-input>
                  <app-input inputType="text" placeholder="Planta" name="floor" [(ngModel)]="selectedPerceptor.floor"></app-input>
                  <app-input inputType="text" placeholder="Puerta" name="door" [(ngModel)]="selectedPerceptor.door"></app-input>
                  <app-input inputType="text" placeholder="Complemento" name="complement" [(ngModel)]="selectedPerceptor.complement"></app-input>

                  <div>
                    <span class="m180-field-label">Código provincia (inmueble)</span>
                    <select [(ngModel)]="selectedPerceptor.provinceCode" (change)="onChangeProvinceModal()" class="m180-native-select">
                      <option [ngValue]="''">--</option>
                      <option *ngFor="let pr of provinces; trackBy: trackByIndex" [ngValue]="pr.provinceCode">
                        {{ pr.provinceName || pr.name || pr.descripcion }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <span class="m180-field-label">Código municipio</span>
                    <select [(ngModel)]="selectedPerceptor.municipalityCode" (change)="onChangeMunicipalityModal()" class="m180-native-select">
                      <option [ngValue]="''">--</option>
                      <option *ngFor="let mu of municipalities; trackBy: trackByIndex" [ngValue]="mu.municipalityCode || mu.code || mu.id">
                        {{ mu.municipalityName || mu.name || mu.descripcion }}
                      </option>
                    </select>
                  </div>

                  <div>
                    <span class="m180-field-label">Localidad / población</span>
                    <select [(ngModel)]="selectedPerceptor.municipalityCode" (change)="onChangeMunicipalityModal()" class="m180-native-select">
                      <option [ngValue]="''">--</option>
                      <option *ngFor="let mu of municipalities; trackBy: trackByIndex" [ngValue]="mu.municipalityCode || mu.code || mu.id">
                        {{ mu.municipalityName || mu.name || mu.descripcion }}
                      </option>
                    </select>
                  </div>

                  <app-input inputType="text" placeholder="Código postal" name="postalCode" [(ngModel)]="selectedPerceptor.postalCode"></app-input>
                </div>
              </div>
            </div>
          </ng-template>

        </div>
      </div>
    </mat-tab>

  </mat-tab-group>

  <app-tax-disclaimer-notice></app-tax-disclaimer-notice>
</div>
